/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { cssMap, jsx } from '@compiled/react';
import { useIntl } from 'react-intl-next';

import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

import messages from './messages';

export function ObjectListFlyoutLoadingState() {
	const { formatMessage } = useIntl();

	return (
		<div data-testid="object-list-flyout--loading-state">
			<div role="status">
				<VisuallyHidden>{formatMessage(messages.loadingStateAccessibleName)}</VisuallyHidden>
			</div>
			<div css={loadingStateStyles.wrapper}>
				<Skeleton width="100%" height={8} />
				<Skeleton width="100%" height={8} />
				<Skeleton width="100%" height={8} />
				<Skeleton width="100%" height={8} />
			</div>
		</div>
	);
}

const loadingStateStyles = cssMap({
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: token('space.400'),
		paddingBlock: token('space.400'),
		paddingInline: token('space.050'),
		marginBlockEnd: token('space.100'),
	},
});
